import * as R from 'ramda';

export default function ImpactAnalysisProcessController(
  $q,
  $timeout,
  $rootScope
) {
  const vm = this;

  vm.hasGraph = false;
  vm.isExpanded = false;
  vm.riskViewType = 'graphical';

  vm.handleExpandImpactAnalysisProcess = _handleExpandImpactAnalysisProcess;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _setStatus();
    vm.canExpand = vm.status !== 'Not Started';

    if (vm.process.isManaged === true) {
      vm.canExpand = false;
    }
  }

  function _handleExpandImpactAnalysisProcess() {
    if (vm.canExpand) {
      if (!vm.hasGraph) {
        $timeout(() => {
          $rootScope.$broadcast('reRenderImpactAnalysisGraph', { processId: vm.process.processId, });
          vm.hasGraph = true;
          }, 20);
      }
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _setStatus() {
    const processHasChanges = !R.isNil(vm.process.recoveryTimeObjective)
      || !R.isNil(vm.process.maximumAcceptableDowntime)
      || !R.isNil(vm.process.notes)
      || !R.isNil(vm.process.backupPlatforms)
      || !R.isNil(vm.process.backupFrequencyOptionID)
      || !R.isNil(vm.process.methodOfBackup)
      || !R.isNil(vm.process.timeToRestore)
      || !R.isNil(vm.process.recoveryPriority);

    if (R.isNil(vm.process.impactAnalysis) || !processHasChanges) {
      vm.status = 'Not Started';
    } else if (!vm.process.impactAnalysis.submitted) {
      vm.status = 'In Progress';
    } else if (!vm.process.impactAnalysis.approved) {
      vm.status = 'Awaiting Approval';
    } else if (!vm.process.impactAnalysis.prioritized) {
      vm.status = 'Awaiting Prioritization';
    } else {
      vm.status = 'Complete';
    }

    if (vm.process.isManaged === true) {
      vm.status = 'Complete';
    }
  }
}

ImpactAnalysisProcessController.$inject = [
  '$q',
  '$timeout',
  '$rootScope'
];
